import React, { useState } from "react";
import { Plus, Edit } from "lucide-react";

export default function Store() {
  const [showModal, setShowModal] = useState(false);

  const stores = [
    {
      name: "Router Kart admin demo store",
      url: "https://admin-demo.Router Kart.com/",
      order: 1,
    },
  ];

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="max-w-6xl mx-auto bg-white shadow-md rounded-lg p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-semibold text-gray-800">Stores</h2>
          <button
            onClick={() => setShowModal(true)}
            className="flex items-center bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            <Plus className="w-5 h-5 mr-2" />
            Add new
          </button>
        </div>

        <p className="text-sm text-gray-600 mb-3">
          Learn more about{" "}
          <a href="#" className="text-blue-600 underline">
            multi-store
          </a>
        </p>

        <div className="overflow-x-auto border rounded">
          <table className="min-w-full border-collapse text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="text-left py-2 px-4 border-b">Store name</th>
                <th className="text-left py-2 px-4 border-b">Store URL</th>
                <th className="text-left py-2 px-4 border-b">Display order</th>
                <th className="text-left py-2 px-4 border-b">Edit</th>
              </tr>
            </thead>
            <tbody>
              {stores.map((store, i) => (
                <tr key={i} className="hover:bg-gray-50">
                  <td className="py-2 px-4 border-b">{store.name}</td>
                  <td className="py-2 px-4 border-b text-blue-600 underline">
                    {store.url}
                  </td>
                  <td className="py-2 px-4 border-b">{store.order}</td>
                  <td className="py-2 px-4 border-b">
                    <button className="flex items-center bg-gray-100 hover:bg-gray-200 px-3 py-1 rounded">
                      <Edit className="w-4 h-4 mr-1" /> Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && <AddEmailModal onClose={() => setShowModal(false)} />}
    </div>
  );
}

function AddEmailModal({ onClose }) {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50">
      <div className="bg-white rounded-lg w-full max-w-2xl shadow-lg p-6">
        <h3 className="text-2xl font-semibold mb-6">Add a new email account</h3>
        <form className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Email address *
              </label>
              <input
                type="email"
                className="w-full border rounded px-3 py-2 mt-1"
                placeholder="Enter email address"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Email display name *
              </label>
              <input
                type="text"
                className="w-full border rounded px-3 py-2 mt-1"
                placeholder="Enter display name"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Host
              </label>
              <input
                type="text"
                className="w-full border rounded px-3 py-2 mt-1"
                placeholder="smtp.yourhost.com"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Port
              </label>
              <input
                type="number"
                className="w-full border rounded px-3 py-2 mt-1"
                defaultValue={25}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                SSL
              </label>
              <input type="checkbox" className="mt-2" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Max number of emails
              </label>
              <input
                type="number"
                className="w-full border rounded px-3 py-2 mt-1"
                defaultValue={50}
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Authentication method
            </label>
            <select className="w-full border rounded px-3 py-2 mt-1">
              <option>No authentication</option>
              <option>Basic authentication</option>
              <option>OAuth2</option>
            </select>
          </div>

          <div className="flex justify-end mt-6 space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
            >
              Cancel
            </button>
            <button className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
              Save
            </button>
            <button className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
              Save and Continue Edit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
